"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _configuration = require("../../configuration");

function onSpreadValue() {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (action) {
    return action.payload;
  };
  return function (state, action) {
    return (0, _configuration.mergeState)(state, selector(action, state));
  };
}

var _default = onSpreadValue;
exports["default"] = _default;